import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";

export class Company {
  constructor() {}

  async isDuplicateCode(code) {
    const eventByCode = /* GraphQL */ `
      query EventByCode(
        $sortDirection: ModelSortDirection
        $filter: ModelEventFilterInput
        $limit: Int
        $nextToken: String
      ) {
        eventByCode(
          code: "${code}"
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            name
            code
            type
            requireDob
            iCalendar
            status
            message
            description
            commsTemplate
            bloodDropStart
            bloodDropEnd
            urinePotLocation
            preQuestionTemplate
            createdAt
            isDeleted
            updatedAt
          }
          nextToken
        }
      }
    `;
    event = await API.graphql(
      graphqlOperation(eventByCode, {
        filter: { isDeleted: { eq: 0 } },
        limit: 100,
      })
    );
    if (event.data.eventByCode.items.length > 0) {
      return true;
    }
    return false;
  }

  async isDuplicateCompany(companyName) {
    const {
      data: {
        listEventCompanies: { items: company },
      },
    } = await API.graphql(
      graphqlOperation(queries.listEventCompanies, {
        filter: { isDeleted: { eq: 0 }, name: { eq: companyName } },
        limit: 100,
      })
    );
    if (company.length > 0) {
      return true;
    }
    return false;
  }
}